import React, { useEffect, useState } from 'react';
import '../solutions/Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionCentralOffice.mp4",
    poster: "/videos/solutionCentralOffice.jpg",
    heading: "Decoding the Go!Foton Brand",
    subheading: "April 25th, 2025",
    buttonLink: "/support"
  }
];

function BlogTheGofotonBrand() {

const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

const [open, setOpen] = useState(new Set());

  const toggle = (key) => {
    setOpen((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  };


const productFamilies = [
  'Fiber Cable Assemblies',
  'Fiber Panels',
  'Frames',
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products



useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="curved-header-sol2" style={{paddingBottom: 60}}>
        <div className="datacenter-left" style={{ paddingTop: 100}}>
            <h1>{slides[0].heading}</h1>
            <p style={{ marginBottom: 40, fontSize: 20}}>{slides[0].subheading}</p>
            </div>
            <div className="datacenter-right" style={{ paddingTop: 60}}>
              <img src="/images/blog/decoding.png" className="datacenter-img" />
            </div>
            </div>



      <div className="blog-section-1" style={{ marginTop: 30}}>

          <p className="solution-section-1-description">Throughout our hundred-year history from glass to optics and photonics, we have grown and adapted. Our logo is a symbol of that progress. It leans forward, signifying progress and always looking ahead. And the exclamation point in our written name is a testament to our excitement for what we do. Within our logo, the “o” and leaf shape above symbolize that exclamation point. Pointed upwards, the leaf symbolizes progress, growth, and our belief that the sky is the limit when imagining what’s possible and delivering what’s next. The design is purposeful, and it’s a nod to nature – a source of our inspiration and a prevalent pattern in our look.<br/><br/>
As engineers with foundations in physics and fractal geometry, we are inspired by the patterns, structure, and design in our natural world and refer to its principles when innovating. Our colors and imagery are bold and vibrant like our imaginations.<br/><br/>

<b>But brands are more than a name and a look </b><br/>

The Go!Foton brand communicates who we are, what motivates us, and will evolve with us. Each day, our mission is to <b>bring light to life</b>. With a focus on optics and photonics across a variety of industries and applications, we help you make discoveries and share our excitement about technology with you. ​<br/><br/>

Our cornerstones are the guideposts for our decision-making and approach from problem-solving to building relationships. We believe:<br/><br/>

<ol style={{margin: 0}}>
    <li>The best things happen when we champion one another, act with integrity, and embrace everyone’s creativity to solve problems. When we align people’s passions and care for the needs of all stakeholders, we develop more creative content to positively impact society.​</li>
    <li>Innovation via the right dimension – We innovate with purpose. You’re that purpose. It’s our aim to understand your technical and business needs and points of view to create solutions that bring you value.​</li>
    <li>Customer experience – We are as good as customers think we are. And we aim to delight customers by wrapping them in love. That’s why our customers turn to us again and again.​</li>
    <li>Data-supported, fact-based, process-oriented decision-making ​ – Make the best possible decision when a decision is necessary by considering all available information and needs.​</li>
    <li>Interest alignment – Let’s win together. The best outcomes are achieved when everyone that’s involved benefits.</li>
    <li>Results delivered​ -We set and measure ourselves against aggressive objectives because we dare to be the best and we’re driven to achieve.​</li>
  </ol><br/><br/>

</p>
      </div>

      <div className="solutions-section-imageBackground-blog" style={{ position: 'relative'}}>
        
        <div className="solutions-section-imageBackground-text-container">
          <h2 className="solutions-section-imageBackground-subheading" style={{ marginTop: -60}}>Our promise to you</h2>
        </div>
        
      </div>

<svg style={{ marginTop: -140}} className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
        <path
          d="
            M0,150
            H1440
            V0
            Q720,75 0,0
            Z
          "
          fill="white"
        />
      </svg>


      <div className="blog-section-1" style={{ marginTop: -10}}>

          <p className="solution-section-1-description">We have a mantra. It’s <b>“finding the right dimension”</b>. It’s a belief that we all have unique and valuable perspectives to share. We each imagine how to solve problems in unique ways. And finding the best approach underpins the design, performance, and usability of our products.​ One example is from our PEACOC spreadable adapters, inspired by the fanning of a peacock’s tailfeathers. Used in our networking connectivity solutions, the adapter arms are designed to be movable, making accessing fiber connectors much easier for technicians working in very dense equipment racks.​ No one else builds this way. This is purely derived by innovating with purpose for our customers’ experience. Our muse is nature. Our language is science.<br/><br/>
Being inspired by nature and propelled by physics helps us make discoveries that stand out from our competition and gives our customers an advantage. Each day we apply visionary thinking to everyday problems, create technical solutions that make meaningful business impact, invite collaboration and sharing, and aspire to make the complex simple.<br/><br/>


We believe the sky is the limit when imagining what’s possible and creating what’s next. Expect us to deliver on our promises because your experience matters. Look to us as your <b>innovator, expert, and problem solver.</b>​<br/><br/>

</p>
      </div>

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{ backgroundColor: 'white'}}></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default BlogTheGofotonBrand;
